export const GRAPH_API_PROFILE = process.env.REACT_APP_GRAPH_API_PROFILE
export const GRAPH_API_PREDICTION = process.env.REACT_APP_GRAPH_API_PREDICTION
export const GRAPH_API_LOTTERY = process.env.REACT_APP_GRAPH_API_LOTTERY
export const SNAPSHOT_VOTING_API = process.env.REACT_APP_SNAPSHOT_VOTING_API
export const SNAPSHOT_BASE_URL = process.env.REACT_APP_SNAPSHOT_BASE_URL
export const SNAPSHOT_API = `${SNAPSHOT_BASE_URL}/graphql`
export const SNAPSHOT_HUB_API = `${SNAPSHOT_BASE_URL}/api/message`
export const BITQUERY_API = 'https://graphql.bitquery.io'

/**
 * V1 will be deprecated but is still used to claim old rounds
 */
export const GRAPH_API_PREDICTION_V1 = 'https://api.thegraph.com/subgraphs/name/pancakeswap/prediction'

export const INFO_CLIENT = 'https://thegraph.coin.one/subgraphs/name/coinoneswap/exchange'
export const BLOCKS_CLIENT = 'https://thegraph.coin.one/subgraphs/name/coinoneswap/blocks'
// export const BLOCKS_CLIENT = 'https://api.thegraph.com/subgraphs/name/pancakeswap/blocks'

export const GRAPH_HEALTH = 'https://api.thegraph.com/index-node/graphql'

export const ACCESS_RISK_API = '/api/risk'

// NFT Sale subgraph endpoint - can be overridden by environment variable
export const GRAPH_API_NFT_SALE = process.env.REACT_APP_GRAPH_API_NFT_SALE || ''

// NFT Sale subgraph endpoints by chain ID
export const GRAPH_API_NFT_SALE_BY_CHAIN: { [chainId: number]: string } = {
  // Add your subgraph endpoints here
  // Example:
  56: 'https://api.studio.thegraph.com/query/106608/nftsale-bsc/version/latest',
  97: 'https://api.studio.thegraph.com/query/106608/nftsale-bsctest/version/latest',
}
